export default __webpack_public_path__ + "static/media/bae_logo.37d17707.svg";